import { useState, useCallback } from "react";

export interface ContactInfo {
    name: string;
    email: string;
    phone: string | null;
    message: string;
}

export default function useContact(baseUrl: string) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    // Submit contact form
    const sendContact = useCallback(async (payload: ContactInfo) => {
        setLoading(true);
        setError(null);

        try {
            const headers = {
                'Content-Type': 'application/json',
                'Accept-Encoding': 'gzip, deflate, br',
            };

            const response = await fetch(`${baseUrl}contact`, {
                method: 'POST',
                body: JSON.stringify(payload),
                headers,
            }).then(async (data) => {
                const resp = data.json();
                return resp;
            });

            return response;

        } catch (err: any) {
            setError(err.message || "Something went wrong");
            throw err;
        } finally {
            setLoading(false);
        }
    }, [baseUrl]);

    return {
        data,
        loading,
        error,
        sendContact,
    };
}